import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import Registro from "./Registro";
import Oferta from "./Oferta";

import { ConsultaProfesores } from '../../funciones/RegistroFunction';
import { ConsultSemestres } from '../../funciones/MateriasFunction';


class MainSecciones extends Component {
    state = {
        valorActividad: { value: 'registro', label: 'Registrar Secciones' },
        profesores:[],
        semestres:[],
    }

    componentDidMount = () => {
        ConsultaProfesores ((resp) => {
            this.setState({profesores: resp})
        })

        ConsultSemestres ((resp) => {
            this.setState({semestres: resp})
        })
    }

    Selecciona = (link) => {
        switch (link) {
            case "/secciones/registro":
                return({ value: 'registro', label: 'Registrar Secciones' })
            case "/secciones/oferta":
                return({ value: 'oferta', label: 'Oferta Académica' })
            default:
                return({ value: 'registro', label: 'Registrar Secciones' })
        }
    }

    valorRegistroLabel = (link) => {
        switch (link) {
            case "/secciones/registro": return('Registrar Secciones')
            case "/secciones/oferta": return('Oferta Académica')
            default: return('Registrar Secciones')
        }
    }

    valorActividad = (valorActividad) => {
        this.setState({
            valorActividad
        },() => {
            this.props.history.push(`/secciones/${this.state.valorActividad.value}`);
        });
    }

    contenido = () => {
        let {profesores,semestres} = this.state;

        return (
            <Switch>
                <Route path="/secciones/registro" component={ () => <Registro profesores = {profesores} semestres = {semestres}/> } />
                <Route path="/secciones/oferta" component={ () => <Oferta profesores = {profesores} semestres = {semestres}/> } />
                <Redirect to = "/secciones/registro" />
            </Switch>
        )
    }

    render() {
        const Registros = [
            { value: 'registro', label: 'Registrar Secciones' },
            { value: 'oferta', label: 'Oferta Académica' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona una actividad
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorActividad}
                                    options={Registros}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`${this.valorRegistroLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default MainSecciones;


// WEBPACK FOOTER //
// ./src/views/Secciones/MainSecciones.jsx